// eslint-disable-next-line import/no-cycle
import type { Fields } from "@vuex-orm/core";
import { BrowserAction } from "./ActionHierarchy";
import type { Timings } from "./ActionTypes";

export class Click extends BrowserAction {
  // This is the name used as module name of the Vuex Store.
  public static entity = "clicks";

  public static baseEntity = "actions";

  public static fields(): Fields {
    return {
      ...super.fields(),
      // job: this.attr('')
    };
  }

  public get defaultTimings(): Omit<Required<Timings>, "total"> {
    if (this.speed === "fast")
      return {
        before: 0.1,
        beforeHover: 0,
        hover: 0,
        down: this.animated ? 0.3 : 0,
        main: this.animated ? 0.3 : 0,
        after: 0.1,
      };

    if (this.speed === "medium")
      return {
        before: 0.1,
        beforeHover: 0.1,
        hover: this.animated ? 0.3 : 0,
        down: this.animated ? 0.3 : 0,
        main: this.animated ? 0.3 : 0,
        after: 0.4,
      };

    return {
      before: 0.3,
      beforeHover: 0.2,
      hover: this.animated ? 0.6 : 0,
      down: this.animated ? 0.6 : 0,
      main: this.animated ? 0.6 : 0,
      after: 1,
    };
  }

  public static get humanName(): string {
    return "Click";
  }

  // we probably want to build the descriptions in multiple steps:
  // 1. get the element description

  public get verb(): string {
    if (this.isTextField) return "select";
    return "click";
  }

  public get prefix(): string {
    // fixme: find a better name than prefix
    if (this.isUnknownCategory) return "on";
    return "the";
  }

  public get description(): string {
    const words: string[] = [];
    words.push(this.verb);
    if (this.isButton && this.elementDescription) {
      words.push("the");
      words.push(this.elementDescription);
      // if(this.element?.value) words.push(this.element.value);
      // else if (this.element.innerText) words.push(this.element.innerText);
      // words.push("button");
    } else if (this.elementDescription) {
      if (this.isUnknownCategory) words.push("on");
      else words.push("the");
      words.push(this.elementDescription);
    } else if (
      this.element &&
      typeof (this.element as HTMLElement).innerText === "string" &&
      (this.element as HTMLElement).innerText.replace(/SCRIPT_PLACEHOLDER/g, "")
    ) {
      words.push(
        `on “${(this.element as HTMLElement).innerText.replace(/SCRIPT_PLACEHOLDER/g, "")}”`,
      );
    } else {
      words.push("here");
    }
    const sentence = words.join(" ");
    return sentence.charAt(0).toUpperCase() + sentence.slice(1);
  }
}
